import type { CSSProperties } from "react";
import type { ISkeletonProps } from "./types";
import "./index.css";
import { clsx } from "clsx";

export const Skeleton = (props: ISkeletonProps) => {
  const {
    width = "200px",
    height = "1.43rem",
    shape = "rounded",
    className,
    color = "layer3",
    style: styles,
  } = props;

  const customStyle: CSSProperties = styles || {};

  const style: CSSProperties = {
    ...customStyle,
    width,
    height,
    borderRadius: shape === "round" ? height : "0.5rem",
  };

  const rootClass: string = clsx(
    `nuco-skeleton nuco-skeleton--${color}`,
    className,
  );

  return <div className={rootClass} style={style} />;
};
